import { BaseElement, defineElement } from "./lib-element-js.min.js";

class Calculator extends BaseElement {
  content = this.getAttribute("data-package_content");
  required_quantity = this.querySelector('[name="required_quantity"]');
  quantity = this.querySelector('.quantity_input');
  min_quantity =
    typeof this.quantity.getAttribute("min") == "number"
      ? this.quantity.getAttribute("min")
      : 1;
  extra = this.querySelector('[name="extra"]');
  submitform_quantity = document.querySelector(
    '.product-form__quantity [name="quantity"]'
  );

  // lifecycle hook
  connected() {
    this.required_quantity.addEventListener("keyup", () => {
      this.calculate();
    });
    this.required_quantity.addEventListener("mouseup", () => {
      this.calculate();
    });
    this.required_quantity.addEventListener("change", () => {
      this.calculate();
    });

    this.extra.addEventListener("keyup", () => {
      this.calculate();
    });
    this.extra.addEventListener("mouseup", () => {
      this.calculate();
    });
    this.extra.addEventListener("change", () => {
      this.calculate();
    });

    this.quantity.addEventListener("change", () => {
      this.setMinMinvalue(this.quantity.value);
    });
  }

  // reactive attributes/properties
  properties() {
    return {};
  }

  get getExtra() {
    return (this.required_quantity.value / 100) * this.extra.value.slice(0, -2);
  }

  setMinMinvalue(newValue) {
    if (Number(newValue) >= Number(this.quantity.getAttribute('min'))) {
      this.submitform_quantity.value = newValue;
    } else {
      this.quantity.value = this.quantity.getAttribute('min');
      this.submitform_quantity.value = this.quantity.getAttribute('min');
    }
  }

  calculate() {
    const calculated = Math.ceil(
      (Number(this.required_quantity.value) + Number(this.getExtra)) /
        this.content
    );
    if (calculated >= this.min_quantity) this.quantity.value = calculated;
    else this.quantity.value = this.min_quantity;

    this.setMinMinvalue(calculated);
  }
}
defineElement("fw-calculator", Calculator);
